import { Link } from "react-router-dom";
import { Crown, Heart } from "lucide-react";
import { dynamicLabel } from "../lib/api";
import { FALLBACK_PHOTO } from "../lib/ui";

const LockedBanner = () => (
  <div
    data-testid="admirers-locked"
    className="mt-6 bg-[#F3F0EA] border border-[#C19A6B] p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-6"
  >
    <div>
      <p className="font-serif text-xl flex items-center gap-2">
        <Crown className="w-5 h-5 text-[#C19A6B]" strokeWidth={1.5} /> Someone already said yes to you.
      </p>
      <p className="mt-2 text-sm text-[#5C5C5C]">
        Upgrade to Premium to see exactly who's interested — and match instantly.
      </p>
    </div>
    <Link
      to="/premium"
      data-testid="admirers-upgrade-link"
      className="bg-[#7A3B3F] text-[#FAF9F6] px-8 py-3 text-center hover:bg-[#5D2B2E] transition-colors duration-300 whitespace-nowrap"
    >
      Reveal them
    </Link>
  </div>
);

const AdmirerCard = ({ profile: p, onLikeBack }) => (
  <div data-testid={`admirer-card-${p.id}`} className="bg-[#F3F0EA] border border-[#E5E0D8]">
    <div className="aspect-square overflow-hidden">
      <img src={p.photo_url || FALLBACK_PHOTO} alt={p.name} className="w-full h-full object-cover" />
    </div>
    <div className="p-4">
      <h3 className="font-serif text-lg truncate">
        {p.name}, {p.age}
      </h3>
      <p className="text-xs uppercase tracking-[0.15em] text-[#7A3B3F] truncate">
        {dynamicLabel(p.relationship_dynamic)}
      </p>
      <button
        data-testid={`admirer-like-back-${p.id}`}
        onClick={() => onLikeBack(p)}
        className="mt-3 w-full bg-[#7A3B3F] text-[#FAF9F6] py-2 text-sm hover:bg-[#5D2B2E] transition-colors duration-300"
      >
        Like back
      </button>
    </div>
  </div>
);

export const AdmirersSection = ({ admirers, onLikeBack }) => {
  if (!admirers || admirers.count === 0) return null;
  return (
    <div className="mt-12" data-testid="admirers-section">
      <h2 className="font-serif text-2xl flex items-center gap-2">
        <Heart className="w-5 h-5 text-[#7A3B3F]" strokeWidth={1.5} />
        {admirers.count} {admirers.count === 1 ? "person is" : "people are"} interested in you
      </h2>
      {admirers.locked ? (
        <LockedBanner />
      ) : (
        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-6">
          {admirers.profiles.map((p) => (
            <AdmirerCard key={p.id} profile={p} onLikeBack={onLikeBack} />
          ))}
        </div>
      )}
    </div>
  );
};
